import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { Box } from "theme-ui";
export default React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, props, {
    __themeKey: "dividers",
    __css: {
      marginTop: function marginTop(theme) {
        var _theme$dividers$root;

        return "".concat(((_theme$dividers$root = theme.dividers.root) === null || _theme$dividers$root === void 0 ? void 0 : _theme$dividers$root.marginTop) || "18px");
      },
      height: function height(theme) {
        var _theme$dividers$root2;

        return "".concat(((_theme$dividers$root2 = theme.dividers.root) === null || _theme$dividers$root2 === void 0 ? void 0 : _theme$dividers$root2.height) || "3px");
      },
      width: function width(theme) {
        var _theme$dividers$root3;

        return "".concat(((_theme$dividers$root3 = theme.dividers.root) === null || _theme$dividers$root3 === void 0 ? void 0 : _theme$dividers$root3.width) || "224px");
      },
      border: 0,
      color: "transparent",
      background: function background(theme) {
        var _theme$dividers$root4;

        return "".concat(((_theme$dividers$root4 = theme.dividers.root) === null || _theme$dividers$root4 === void 0 ? void 0 : _theme$dividers$root4.background) || theme.colors.primary);
      }
    }
  }));
});